import type { StaticImageData } from "next/image";
import Image from "next/image";

export const SplashImage = ({
  src,
  left,
  circle = false,
  fuckAll = false,
}: {
  src?: StaticImageData | string;
  left?: StaticImageData | string;
  circle?: boolean;
  fuckAll?: boolean;
}) => {
  return (
    <div
      className={`absolute left-0 top-0 h-[calc(74vh)] max-h-[650px] w-full gradient-mask-b-60 sm:h-[calc(76vh)] md:h-[calc(80vh)] 
      ${!left && "bg-map2 bg-repeat"}
      ${fuckAll && "brightness-50"}
      `}
    >
      {/* left */}
      {left && (
        <div
          className={
            "absolute left-0 top-0 hidden h-full w-full max-w-[1200px] duration-700 animate-in fade-in gradient-mask-r-40 sm:w-1/2 lg:block "
          }
        >
          <Image
            priority={true}
            placeholder="blur"
            blurDataURL={typeof left === "string" ? left : undefined}
            src={left}
            fill={true}
            className={
              "object-cover object-[center_100%] brightness-90 gradient-mask-l-50 sm:object-[center_38%] sm:brightness-110"
            }
            alt={""}
          />
        </div>
      )}

      {/* right */}
      {src && (
        <div
          className={
            "absolute right-0 top-0 h-full w-full max-w-[1200px] duration-700 animate-in fade-in gradient-mask-b-60 sm:w-4/5 md:w-3/4"
          }
        >
          <Image
            priority={true}
            placeholder="blur"
            blurDataURL={typeof src === "string" ? src : undefined}
            src={src}
            fill={true}
            className={
              "object-cover object-[center_40%] brightness-90 gradient-mask-l-60 sm:object-[center_50%] md:object-[center_40%] lg:object-[center_30%]"
            }
            alt={""}
          />
        </div>
      )}

      {/* gradient */}
      <div
        className="absolute h-full w-full"
        style={{
          backgroundImage: `
      linear-gradient(240deg, rgba(2, 2, 2, 0.1) 0%, rgba(2, 2, 2, 0.1) 40%), 
      linear-gradient(0deg, rgba(2, 2, 2, 0.8) 0%, rgba(2, 2, 2, 0.1) 40%), 
      linear-gradient(120deg, rgba(2, 2, 2, 0.8) 0%, rgba(2, 2, 2, 0.1) 60%), 
      linear-gradient(180deg, rgba(2, 2, 2, 0.5) 0%, rgba(2, 2, 2, 0.1) 30%),
      linear-gradient(to top, rgba(2, 2, 2, 0.6) 0%, rgba(2, 2, 2, 0.1) 50%)`,
        }}
      />
      {circle && (
        <div className="absolute h-full w-full gradient-mask-b-70 [background-image:radial-gradient(circle,_rgba(0,0,0,0.5)_40%,_rgba(0,0,0,0)_60%)]" />
      )}
    </div>
  );
};
